
import {
  postPayloadCommands,
  PayloadCommandsEnum,
  PostGimbalResetBody,
  PostCameraFocalLengthBody,
  PostCameraAimBody,
  PostCameraModeBody
} from '@/api/drone-control/payload'
import { ControlSource } from '@/types/enum'

export function usePayloadControl () {
  function checkPayloadAuth (controlSource?: ControlSource) {
    if (controlSource !== ControlSource.A) {
      //message.error('请先获取有效负载控制')
      return false
    }
    return true
  }

  async function resetGimbal (sn: string, data: PostGimbalResetBody) {
    const result = await postPayloadCommands({
      cmd: PayloadCommandsEnum.GimbalReset,
      data: data,
      deviceSn:sn
    })
    ElMessage.success('云台复位成功')
  }

  async function switchCameraMode (sn: string, data: PostCameraModeBody) {
    const result = await postPayloadCommands({
      cmd: PayloadCommandsEnum.CameraModeSwitch,
      data: data,
      deviceSn:sn
    })
    ElMessage.success('相机模式切换成功')
    return result
  }

  async function takeCameraPhoto (sn: string, payloadIndx: string) {
    const result = await postPayloadCommands({
      cmd: PayloadCommandsEnum.CameraPhotoTake,
      data: {
        payload_index: payloadIndx
      },
      deviceSn:sn
    })
    ElMessage.success('拍照成功')
  }

  async function startCameraRecording (sn: string, payloadIndx: string) {
    const result = await postPayloadCommands({
      cmd: PayloadCommandsEnum.CameraRecordingStart,
      data: {
        payload_index: payloadIndx
      },
      deviceSn:sn
    })
    ElMessage.success('成功开始录制')
    return result
  }

  async function stopCameraRecording (sn: string, payloadIndx: string) {
    const result = await postPayloadCommands({
      cmd: PayloadCommandsEnum.CameraRecordingStop,
      data: {
        payload_index: payloadIndx
      },
      deviceSn:sn
    })
    ElMessage.success('成功停止录制')
    return result
  }

  async function changeCameraFocalLength (sn: string, data: PostCameraFocalLengthBody) {
    const result = await postPayloadCommands({
      cmd: PayloadCommandsEnum.CameraFocalLengthSet,
      data: data,
      deviceSn:sn
    })
    ElMessage.success('切换成功')
    return result
  }

  //双击变焦
  async function switchCameraAim (sn: string, data: PostCameraAimBody) {
    const result = await postPayloadCommands({
      cmd: PayloadCommandsEnum.CameraAim,
      data: data,
      deviceSn:sn
    })
    ElMessage.success('双击变焦切换成功')
    return result
  }


  return {
    checkPayloadAuth,
    resetGimbal,
    changeCameraFocalLength,
    switchCameraAim,
    switchCameraMode,
    takeCameraPhoto,
    startCameraRecording,
    stopCameraRecording
  }
}
